//dependencias
import React, { Component } from 'react';

//componentes
import MaternalV from './maternalVeranito'

class Index extends Component {

    render(){
        return(
            <div>
                <MaternalV />
            </div>
        );
    }

}
export default Index;